import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Home'*/ 'src/controllers/Home/Home'),
	loading: Loading,
});
